var _defs, _path, _path2, _g, _g2, _g3, _g4, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComponentboxLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b31e816b77"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 21.328125 148 L 165 148 L 165 332 L 21.328125 332 Z M 21.328125 148 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "99d4aec747"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 151 148 L 353.578125 148 L 353.578125 332 L 151 332 Z M 151 148 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8abd9aef8f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 21.328125 0.304688 L 353.578125 0.304688 L 353.578125 165 L 21.328125 165 Z M 21.328125 0.304688 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b86dc01cd4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 142 287 L 232.832031 287 L 232.832031 374.71875 L 142 374.71875 Z M 142 287 ",
    clipRule: "nonzero"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0160fe",
    d: "M 221.621094 153.003906 L 197.109375 307.140625 M 152.964844 153.003906 L 177.476562 307.140625 M 289.378906 153.003906 L 217.773438 318.75 M 349.222656 151.613281 L 214.480469 327.9375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0160fe",
    d: "M 158.296875 317.964844 L 83.175781 153.789062 M 160.171875 327.9375 L 25.425781 151.613281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b31e816b77)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 162.984375 315.820312 L 87.875 151.636719 L 78.480469 155.933594 L 153.601562 320.109375 Z M 156.082031 331.074219 L 21.328125 154.753906 L 29.527344 148.476562 L 164.28125 324.796875 L 156.082031 331.074219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#99d4aec747)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 224.027344 153.195312 L 213.777344 151.96875 L 195.382812 306.949219 L 205.640625 308.164062 Z M 180.070312 306.917969 L 161.308594 151.980469 L 151.0625 153.226562 L 169.824219 308.152344 Z M 296.429688 156.070312 L 287.058594 151.738281 L 211.425781 315.6875 L 220.796875 320.015625 Z M 218.921875 331.074219 L 210.722656 324.796875 L 345.46875 148.476562 L 353.664062 154.753906 L 218.921875 331.074219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8abd9aef8f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0160fe",
    d: "M 21.328125 154.792969 C 27.59375 68.4375 99.566406 0.304688 187.496094 0.304688 C 275.429688 0.304688 347.410156 68.4375 353.664062 154.792969 C 346.503906 149.207031 337.507812 145.851562 327.707031 145.851562 C 313.128906 145.851562 300.265625 153.226562 292.652344 164.449219 C 285.039062 153.226562 272.1875 145.851562 257.609375 145.851562 C 243.019531 145.851562 230.167969 153.226562 222.550781 164.449219 C 214.9375 153.226562 202.085938 145.851562 187.496094 145.851562 C 172.917969 145.851562 160.054688 153.226562 152.441406 164.449219 C 144.839844 153.226562 131.976562 145.851562 117.394531 145.851562 C 102.808594 145.851562 89.953125 153.226562 82.339844 164.449219 C 74.726562 153.226562 61.875 145.851562 47.285156 145.851562 C 37.496094 145.851562 28.503906 149.207031 21.328125 154.792969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b86dc01cd4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0160fe",
    d: "M 232.5625 297.296875 L 232.5625 353.460938 C 232.5625 365.207031 223.042969 374.71875 211.300781 374.71875 L 163.695312 374.71875 C 151.960938 374.71875 142.445312 365.207031 142.445312 353.460938 L 142.445312 297.296875 C 142.445312 291.84375 146.867188 287.417969 152.316406 287.417969 L 222.679688 287.417969 C 228.136719 287.417969 232.5625 291.84375 232.5625 297.296875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 232.5625 326.179688 L 232.5625 336 L 142.445312 336 L 142.445312 326.179688 L 232.5625 326.179688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponentboxLogo);
export default __webpack_public_path__ + "static/media/componentbox_logo.67212e3a503e0e027e0c0cb02fa870d4.svg";
export { ForwardRef as ReactComponent };